import { Component, OnInit } from '@angular/core';
import { MessageLogService } from 'app/integration/message-log/services/message-log.service';
import { MessageLog } from 'app/integration/message-log/services/message-log';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '@heda/core-hospital-ui';
import { CodeSystemService } from 'app/mdm/terminology-lib/services/codesystem.service';
import { CodeSystemConcept } from 'app/mdm/terminology-lib/services/codesystem';
import { MessageQueueService } from 'app/integration/message-log/services/message-queue.service';
import { MessageQueueItem } from 'app/integration/message-log/services/message-queue-item';
import { prettyJson } from '@heda/core-util/util/json.util';

@Component({
  templateUrl: './log-view.component.html',
  styleUrls: ['./log-view.component.less'],
})
export class LogViewComponent implements OnInit {
  public log: MessageLog;

  public references: { [key: string]: CodeSystemConcept };
  public queueChain: Array<MessageQueueItem>;
  public series: Array<MessageQueueItem>;
  public currentQueueItem: MessageQueueItem;

  constructor(
    private logService: MessageLogService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private codeSystemService: CodeSystemService,
    private messageQueueService: MessageQueueService
  ) {}

  public ngOnInit(): void {
    this.route.paramMap.subscribe(() => {
      this.codeSystemService.getConcepts('log-reference-type').subscribe((resp) => {
        this.references = resp;
      });
      this.init();
    });
  }

  private init(): void {
    this.loadLog(this.route.snapshot.paramMap.get('id'));
  }

  public loadLog(id: string): void {
    this.logService.getLog(id).subscribe((resp) => {
      this.log = resp;
      if (this.log.service.contentType === 'json') {
        if (this.log.request.body) {
          this.log.request.body = prettyJson(this.log.request.body);
        }
        if (this.log.response.body) {
          this.log.response.body = prettyJson(this.log.response.body);
        }
      }
      this.log.request.header = prettyJson(this.log.request.header);
      this.log.response.header = prettyJson(this.log.response.header);
      if (this.log.queueId) {
        this.messageQueueService.getChain(this.log.queueId).subscribe((chain) => {
          this.queueChain = chain.filter((item) => !(item.status === 'STOPPED' && !item.messageLogId));

          this.queueChain.forEach((item) => {
            if (item.messageLogId === this.log.id) {
              this.currentQueueItem = item;
            }
          });
        });
        this.messageQueueService.getSeries(this.log.queueId).subscribe((series) => {
          this.series = series;
        });
      }
    });
  }

  public resend(id: string): void {
    this.logService.resend(id).subscribe(() => {
      this.loadLog(id);
      this.messageService.success('integration.log-02.resend.scheduled');
    });
  }

  public goToList(): void {
    this.router.navigate(['/integration/logs']);
  }

  public searchByMessageId(): void {
    this.router.navigate(['/integration/logs', { messageId: this.log.messageId }]);
  }

  public stopResend(queueId: string): void {
    this.messageQueueService.stopResend(queueId).subscribe(() => {
      this.init();
      this.messageService.success('integration.log-02.resend.stopped');
    });
  }
}
